'use client'

import { FloatingFocusManager, useMergeRefs } from '@floating-ui/react'
import React, { FC, HTMLProps } from 'react'

import { cn } from '../../utils/cn'
import { usePopoverContext } from './popover'

interface PopoverContentProps
  extends HTMLProps<HTMLDivElement | HTMLSpanElement> {
  as?: 'div' | 'span'
}

export const PopoverContent: FC<PopoverContentProps> = ({
  style,
  as = 'div',
  className,
  children,
  ref,
  ...props
}) => {
  const {
    context: floatingContext,
    refs,
    modal,
    floatingStyles,
    labelId,
    descriptionId,
    getFloatingProps
  } = usePopoverContext()
  const mergedRef = useMergeRefs([refs.setFloating, ref])

  const contentClassName = cn(
    'z-5 w-max rounded-xl border border-slate-200 bg-white shadow',
    className
  )

  if (!floatingContext.open) return null

  const Tag = as

  return (
    <FloatingFocusManager context={floatingContext} modal={modal}>
      <Tag
        style={{ ...floatingStyles, ...style }}
        aria-labelledby={labelId}
        aria-describedby={descriptionId}
        {...getFloatingProps({
          ...props,
          ref: mergedRef
        })}
        className={contentClassName}>
        {children}
      </Tag>
    </FloatingFocusManager>
  )
}
